export default "__VITE_ASSET__CBEdnY41__"